import React from 'react';
import useSWR from 'swr';
import { GroupsDetailViewProps } from '../../../types/GroupsDetailView';
import { GroupWatchlistItem } from '../../../types/AlertObject';

// icons
import { ReactComponent as SuccessIcon } from '../../../img/icons/success.svg';
import { ReactComponent as NotWorkingIcon } from '../../../img/icons/not-working.svg';
import Sensors from '../../../utils/Sensors';

function GroupsDetailView(props: GroupsDetailViewProps): JSX.Element {
  const { selectedCustomer, selectedSite, group, descriptionLabel, scheduledDriverLevel } = props;
  let max = 1;
  const percent = 100;
  const colorSwitchAt = 7;

  const { data: groupAlerts } = useSWR<GroupWatchlistItem>(
    selectedSite.id && group.groupId
      ? [`/organizations/${selectedCustomer.id}/sites/${selectedSite.id}/node-alerts-group-watchlist/${group.groupId}`, 'RefreshGroupAlerts']
      : null,
  );

  groupAlerts?.types.forEach((data, index) => {
    if (data.count > max) {
      max = data.count;
    }
  });

  const colors = ['#AC66CF', '#FFED7B', '#C2E28A', '#E0966B', '#65B7E1', '#65C2B6', '#E865BA'];
  return (
    <div className="groups-list-details">
      <div className="groups-list-details__nodes">
        <div className="groups-list-details__nodes-title">
          <span className="groups-list-details__nodes-title-value">
            {group.nodeList.length || 0 }
          </span>
          Total Nodes
        </div>
        <div className="groups-list-details__status-list">
          <div className="groups-list-details__nodes-status">
            <span className="groups-list-details__nodes-status-ok">
              <SuccessIcon />
              {(groupAlerts) ? (group.nodeList.length - groupAlerts?.alertNodeCount) : '-'}
            </span>
            Everything ok
          </div>
          <div className="groups-list-details__nodes-status">
            <span className="groups-list-details__nodes-status-warning">
              <NotWorkingIcon />
              {groupAlerts?.alertNodeCount}
            </span>
            Watch list
          </div>
          {group.type !== 'ORGANIZATIONAL' && (
          <div className="groups-list-details__nodes-status">
            <span className="groups-list-details__nodes-status-schedule">
              {Sensors.getLightsOnIcon(scheduledDriverLevel || 0)}
              {(scheduledDriverLevel || 0).toString()}
              %
            </span>
            Scheduled driver level
          </div>
          )}
        </div>
        <div className="groups-list-details__group-desc">
          <span className="groups-list-details__group-desc-title">{descriptionLabel}</span>
          {group.description}
        </div>
      </div>
      <div className="groups-list-details__alerts">
        <div className="groups-list-details__alerts-title">
          <span className="groups-list-details__alerts-title-value">
            {groupAlerts?.types.length || '0'}
          </span>
          Total alerts
        </div>
        <div className="groups-list-details__alerts-section">
          <div className="groups-list-details__alerts-section--total-alerts">
            {groupAlerts?.types.map((data, index) => (
              <div className="groups-list-details__alerts-all" key={`${index}`}>
                <div className="groups-list-details__alerts-obj">
                  <div className="groups-list-details__alerts-types">{data.type}</div>
                </div>
                <div className="groups-list-details__alerts-value">
                  <span className="groups-list-details__alerts-numbers">
                    <span>{data.count}</span>
                  </span>
                  <div className="groups-list-details__alerts-count">
                    <div style={{ width: `${(data.count / max) * percent}%`, backgroundColor: colors[index % colorSwitchAt], height: '8px' }} />
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

export default GroupsDetailView;
